import { ICategoryItem, IListItems } from "@/interfaces/components"
import { User } from "firebase/auth"
import firebase from "firebase/compat/app"

export enum ContextActionType {
  SET_USER = "SET_USER",
  SET_LOADING = "SET_LOADING",
  LIGHT_THEME = "LIGHT_THEME",
  DARK_THEME = "DARK_THEME",
  SET_THEME = "SET_THEME",
  ADD_CATEGORY = "ADD_GROUP",
  DELETE_CATEGORY = "DELETE_CATEGORY",
  DELETE_ITEM = "DELETE_ITEM",
  SET_GROUPS = "SET_GROUPS",
  DELETE_GROUP = "DELETE_GROUP",
  SET_GROUP_BD_ID = "SET_GROUP_BD_ID",
}

export type loading = "loading" | "idle" | "succeeded" | "failed"

type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key
      }
    : {
        type: Key
        payload: M[Key]
      }
}

type ContextPayload = {
  [ContextActionType.SET_USER]: {
    user: User
    accessToken?: string
    metadata: firebase.auth.UserMetadata | {}
    loading?: loading
    isUser?: boolean
  }
  [ContextActionType.SET_LOADING]: {
    loading: loading
  }
  [ContextActionType.ADD_CATEGORY]: {
    listCategory: ICategoryItem[]
  }
  [ContextActionType.SET_THEME]: {
    theme: "light" | "dark"
  }
  [ContextActionType.DELETE_CATEGORY]: {
    id: string
  }
  [ContextActionType.DELETE_ITEM]: {
    id: string
  }
  [ContextActionType.SET_GROUPS]: {
    listGroups: IListItems[]
    loading?: loading
  }
  [ContextActionType.DELETE_GROUP]: {
    id: string
  }
  [ContextActionType.SET_GROUP_BD_ID]: {
    id: string
  }
}

export type ContextActions =
  ActionMap<ContextPayload>[keyof ActionMap<ContextPayload>]
